import { render, staticRenderFns } from "./BindOrigin.vue?vue&type=template&id=b0336368&scoped=true&"
import script from "./BindOrigin.vue?vue&type=script&lang=js&"
export * from "./BindOrigin.vue?vue&type=script&lang=js&"
import style0 from "./BindOrigin.vue?vue&type=style&index=0&id=b0336368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0336368",
  null
  
)

export default component.exports